// V2 preferences never read or change production account/authentication keys.
const prefix = 'mockup.v2.student.';
export const mockStudentStorage = {
    getItem: (key: string) => localStorage.getItem(prefix + key),
    setItem: (key: string, value: string) => localStorage.setItem(prefix + key, value),
    removeItem: (key: string) => localStorage.removeItem(prefix + key),
};
